module.exports = __webpack_public_path__ + "img/code.ec65a0b8.png";